<template>
  <div class="estate">
    <Loader v-if="isLoading" />

    <div class="container" v-if="!isLoading">
      <div class="h4">{{ estatePage.name }}</div>
      <div class="text">{{ estatePage.description }}</div>
      <div class="image" :style="`background-image: url(${API_URL}${estatePage.preview.url})`">
        <div class="bg">
          <div class="header">
            <div class="name">{{ estatePage.project_description }}</div>
            <div class="name-wide">{{ estatePage.project_name }}</div>
            <a :href="estatePage.link" target="_blank" class="button-link">
              Перейти на сайт
            </a>
          </div>
        </div>
      </div>
      <div class= "amount">
        <div class="amount-item">
          <p>{{ estatePage.parking }}</p>
          <span>Машиномест</span>
        </div>
        <div class="amount-item">
          <p>{{ estatePage.floors }}</p>
          <span>Этажей</span>
        </div>
        <div class="amount-item">
          <p>{{ estatePage.area }}</p>
          <span>Общая площадь объекта (м²)</span>
        </div>
        <div class="amount-item">
          <p>{{ estatePage.apartments }}</p>
          <span>Квартир</span>
        </div>
       </div>
      <div class="textabove marked-text" v-html="marked(estatePage.content)"></div>
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(slide, i) in estatePage.slider" :key="i">
            <img :src="`${API_URL}${slide.url}`" />
          </div>
        </div>
      </div>
      <Pagination :swiper="estateSwiper" />
      <h4 v-if="estatePage.video">Видеоматериал</h4>
      <video
        class="video"
        v-if="estatePage.video"
        :src="getAssetUrl(estatePage.video.url, true)"
        controls
        disablePictureInPicture
        controlslist="nodownload noplaybackrate" />
    </div>
  </div>
</template>

<script>
import '@/assets/sass/estate.sass';
import { getAssetUrl } from '@/helpers';
import config from '@/config';
import { mapState } from 'vuex';
import marked from 'marked';
import Loader from '@/components/Loader.vue';
import Swiper from 'swiper';
import Pagination from '@/components/Pagination.vue';

export default {
  name: 'Estate',
  components: {
    Loader,
    Pagination,
  },
  data() {
    return {
      marked,
      isLoading: true,
      estateSwiper: null,
    };
  },
  computed: {
    ...mapState({
      estatePage: (state) => state.estate.estatePage,
    }),
    API_URL() {
      return config.API_URL;
    },
  },
  methods: {
    loadData() {
      this.$store.dispatch('getEstatePage').then(() => {
        this.isLoading = false;
        this.$nextTick(() => {
          this.estateSwiper = new Swiper('.swiper-container', {
            spaceBetween: 100,
          });
        });
      });
    },
    getAssetUrl(data) {
      return getAssetUrl(data);
    },
  },
  mounted() {
    this.isLoading = true;
    this.loadData();
    this.$emit('setLastCrumb', 'Продажа недвижимости');
  },
};
</script>
